import { createContext } from "react";

import { FileRecordStatus } from "../../../../common/types/FileRecordStatus";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { FileRecordDetails } from "../../../common/file-record-details/FileRecordDetails";
import { FileRecordStatusDetails } from "../../common/types/FileRecordStatusDetails";

export interface FileRecordDetailsStateContext {
    fileRecordDetails: FileRecordDetails;
    setFileRecordDetails(fileRecordDetails: FileRecordDetails): void;

    isLoading: boolean;

    isAuthorized(requiredAccessRight: SprintAccessRight[]): boolean;
    setStatus(status: FileRecordStatus, statusDetails?: FileRecordStatusDetails): void;

    isArchivedContentAssigned: boolean;
    setIsArchivedContentAssigned(isArchivedContentAssigned: boolean): void;
}

const defaultFileRecordDetailsStateContext = {} as FileRecordDetailsStateContext;

export const FileRecordDetailsStateContext = createContext<FileRecordDetailsStateContext>(
    defaultFileRecordDetailsStateContext
);
